import type { UserLocation } from '@/api/schema'
import { Row } from '@/app/components/Flex/Flex'
import { Layout } from '@/app/components/Layout/Layout'
import { Loader } from '@/app/components/Loader/Loader'
import { LocationFormPage } from '@/app/components/LocationFormPage/LocationFormPage'
import { Motion } from '@/app/components/Motion/Motion'
import { UI } from '@/app/components/UI/UI'
import { useBack } from '@/app/hooks/useBack'
import { api } from '@/app/utils/api'
import { metrikaGoal } from '@/app/utils/metrika'
import type { FunctionalComponent } from 'preact'
import { useLayoutEffect, useState } from 'preact/hooks'
import { useSearch } from 'wouter-preact'

export const MoonLocationPage: FunctionalComponent<{
  path?: string
}> = () => {
  const back = useBack('/moon')
  const search = useSearch()
  const locationId = Number(new URLSearchParams(search).get('locationId'))
  const [loading, setLoading] = useState(false)
  const [currentLocation, setCurrentLocation] = useState<UserLocation | null>(null)

  const fetch = async () => {
    try {
      setLoading(true)
      if (!Number.isSafeInteger(locationId) || locationId <= 0) {
        setCurrentLocation(null)
      }
      else {
        const resp = await api.get<UserLocation>(`/location/${locationId}`)
        setCurrentLocation(resp.data)
      }
    }
    catch (e) {
      console.error(e)
      setCurrentLocation(null)
    }
    finally {
      setLoading(false)
    }
  }

  useLayoutEffect(() => {
    fetch()
  }, [locationId])

  return (
    <Layout>
      <Layout.Content
        onBack={back}
      >
        {loading
          ? (
            <Loader.Container>
              <Loader type='base' />
            </Loader.Container>
          )
          : (
            <Motion>
              <Layout.Header>
                Локация
              </Layout.Header>

              <Row gap={15}>
                <LocationFormPage
                  placeholder='Начни вводить город'
                  firstMessage={
                    <>
                      Для лунного календаря лучше выбрать город, где ты сейчас находишься. От этого зависит начало лунных дней.
                      <br />
                      <br />
                      {currentLocation
                        ? `Сейчас выбран город: ${currentLocation.name_ru || currentLocation.name_en}.`
                        : 'Выбери свой город — если ничего не менять, календарь будет рассчитан для Москвы.'}
                    </>
                  }
                  onSelect={async location => {
                    metrikaGoal('calendar_location_selected')
                    await api.put('/calendar/location', {
                      locationId: location.id,
                    })
                    back()
                  }}
                />

                <UI.Button
                  size='l'
                  type='secondary'
                  onClick={back}
                >
                  Назад
                </UI.Button>
              </Row>
            </Motion>
          )}
      </Layout.Content>
    </Layout>
  )
}
